import React from "react";

import { Link } from "react-router-dom";

const BestDealsSquare = ({
  best_deals_img,
  title,
  price,
  link,
}) => {
  return (
    <>
      <div className="list_box col-6 pb-5">
        <Link to={"" + link + ""}>
          <div className="box_img">
            <img src={best_deals_img} alt="service" />
          </div>
        </Link>
        <div className="box_detail d-flex justify-content-between">
          <div className="product_title">
            <p>{title}</p>
          </div>
          <span>{price}</span>
        </div>
      </div>
    </>
  );
};

export default BestDealsSquare;
